import {Grid, TextField, Box} from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import React, {useEffect, useState, Dispatch, SetStateAction} from "react";
import {ColumnSettings} from "@/services/Template/TemplateService";
import CustomNoRowsGrid from "@/components/data-grid/CustomNoRowsGrid";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import {useTranslation} from "react-i18next";
import {useColumnLabel} from "../column-settings/utils";

type LeftProps = {
  columnSettings: ColumnSettings | null;
  updateColumnSettings: (ColumnSettings: ColumnSettings) => void;
};

const Left: React.FC<LeftProps> = ({
                                     columnSettings,
                                     updateColumnSettings,
                                   }) => {
  const [searchKey, setSearchKey] = useState<string>("");
  const {t} = useTranslation();
  const {getColumnLabel} = useColumnLabel();
  // useEffect(() => {
  //   if (columnSettings) {
  //     updateColumnSettings({...columnSettings});
  //   }
  //   console.log("【template_field 数组】", columnSettings?.template_field);
  //   console.log("【template_field 数组】类型", columnSettings, typeof columnSettings);
  // }, [columnSettings]);
  const handleCheckChange = (key: string, checked: boolean) => {
    if (!columnSettings) return;

    // 复制一份新的配置，避免直接修改 props
    const newTemplateField = columnSettings.template_field.map(item =>
      item.key === key ? {...item, isCheck: checked} : item
    );

    // 更新父组件状态
    updateColumnSettings({
      ...columnSettings,
      template_field: newTemplateField
    });
  };
  const filteredItems = columnSettings?.template_field?.filter(item =>
    // item.label.includes(searchKey)
    //  不区分大小写
    getColumnLabel(item.key).toLowerCase().includes(searchKey.toLowerCase())
  ) || [];
  return (
    <Grid
      sx={{
        padding: "2px 10px",
      }}
    >
      <Grid
        sx={{
          marginTop: '10px',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          height: '42px',
        }}
      >
        <TextField
          value={searchKey}
          placeholder={t("common.Search by Column Name")}
          size="small"
          onChange={(e) => setSearchKey(e.target.value)}
          sx={{
            width: '100%',
            padding: '0px 10px',
            '& .MuiInputBase-input': {
              paddingLeft: '10px',
              paddingRight: '36px',
            },
          }}
        />

        {/* 清除叉号 */}
        {searchKey && (
          <ClearIcon
            sx={{
              position: "absolute",
              right: "48px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#999",
              "&:hover": {color: "#666"},
            }}
            onClick={() => setSearchKey('')}
          />
        )}
        {/* 搜索图标 */}
        <SearchIcon
          sx={{
            position: "absolute",
            right: "24px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "#999",
            fontSize: "24px",
          }}
        />
      </Grid>

      <FormGroup
        sx={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          marginTop: "10px",
          marginLeft: "-5px",
        }}
      >
        {filteredItems.length === 0 ? (
          <Grid sx={{
            position: 'absolute',
            top: '50%',
            left: '30%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            textAlign: 'center',
          }}>
            <CustomNoRowsGrid/>
          </Grid>
        ) : (
          filteredItems.map((item) => (
            <FormControlLabel
              sx={{
                width: "40%", margin: "4px", color: "#3D3D3D",
                fontSize: "14px",
              }}
              key={item.key}
              control={
                <Checkbox
                  onChange={(e) => handleCheckChange(item.key, e.target.checked)}
                  checked={item.isCheck}
                />
              }
              disabled={item.required}
              label={getColumnLabel(item.key)}
            />
          ))
        )}
      </FormGroup>
    </Grid>
  );
};

export default Left;
